import { Check } from "lucide-react";
import { useI18n } from "@/i18n/I18nProvider";

const ABOUT_IMG =
  "https://images.pexels.com/photos/7821671/pexels-photo-7821671.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const About = () => {
  const { t } = useI18n();
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-24 md:py-32 border-t border-border"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <div className="lg:col-span-6 order-2 lg:order-1">
            <span className="overline text-muted-foreground">
              {t.about.overline}
            </span>
            <h2
              data-testid="about-heading"
              className="mt-5 font-heading font-semibold text-4xl md:text-5xl leading-[1.05] tracking-tight text-foreground"
            >
              {t.about.heading_1}{" "}
              <span className="italic font-light text-primary">
                {t.about.heading_em}
              </span>{" "}
              {t.about.heading_2}
            </h2>
            <p className="mt-6 text-base md:text-lg text-muted-foreground leading-relaxed max-w-xl">
              {t.about.subtitle}
            </p>

            <ul className="mt-10 space-y-4">
              {t.about.bullets.map((b, i) => (
                <li
                  key={i}
                  data-testid={`about-bullet-${i}`}
                  className="flex items-start gap-3"
                >
                  <span className="mt-1 w-5 h-5 rounded-full bg-primary/10 text-primary inline-flex items-center justify-center shrink-0">
                    <Check className="w-3 h-3" strokeWidth={3} />
                  </span>
                  <span className="text-base text-foreground">{b}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-6 order-1 lg:order-2">
            <div className="relative">
              <div className="aspect-[4/5] md:aspect-[5/6] overflow-hidden rounded-sm">
                <img
                  src={ABOUT_IMG}
                  alt="dbrinvest.cz"
                  className="w-full h-full object-cover"
                  data-testid="about-image"
                />
              </div>
              <div className="absolute bottom-6 right-6 md:-bottom-8 md:-right-8 bg-primary text-primary-foreground p-6 md:p-8 max-w-[340px] rounded-sm">
                <div className="overline text-secondary">
                  {t.about.badge_overline}
                </div>
                <blockquote className="mt-3 font-heading italic text-lg md:text-xl leading-snug text-primary-foreground">
                  <span className="text-secondary mr-1">„</span>
                  {t.about.badge_quote}
                  <span className="text-secondary ml-0.5">"</span>
                </blockquote>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
